<div class="border border-stone-200 rounded-xl overflow-hidden bg-white">

  <!-- Tab + Toolbar row -->
  <div class="flex items-center bg-stone-50 border-b border-stone-200">

    <!-- Tabs -->
    <button type="button" (click)="setMode('visual')"
      class="px-3 py-2 text-xs font-bold uppercase tracking-wider border-b-2 transition-all"
      [class.border-primary-500]="editorMode() === 'visual'"
      [class.text-stone-800]="editorMode() === 'visual'"
      [class.bg-white]="editorMode() === 'visual'"
      [class.border-transparent]="editorMode() !== 'visual'"
      [class.text-stone-400]="editorMode() !== 'visual'">
      Aperçu
    </button>
    <button type="button" (click)="setMode('code')"
      class="px-3 py-2 text-xs font-bold uppercase tracking-wider border-b-2 transition-all"
      [class.border-primary-500]="editorMode() === 'code'"
      [class.text-stone-800]="editorMode() === 'code'"
      [class.bg-white]="editorMode() === 'code'"
      [class.border-transparent]="editorMode() !== 'code'"
      [class.text-stone-400]="editorMode() !== 'code'">
      Code
    </button>

    <!-- Toolbar — visual mode only -->
    <div *ngIf="editorMode() === 'visual'" class="flex items-center gap-0.5 ml-2 pl-2 border-l border-stone-200">

      <button type="button" (click)="execFormat('bold')" title="Gras"
        class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded text-sm font-bold transition-colors">B</button>

      <button type="button" (click)="execFormat('italic')" title="Italique"
        class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded text-sm italic transition-colors">I</button>

      <button type="button" (click)="execFormat('underline')" title="Souligné"
        class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded text-sm underline transition-colors">U</button>

      <div class="w-px h-4 bg-stone-200 mx-1"></div>

      <button type="button" (click)="insertHeading('h2')" title="Titre H2"
        class="px-2 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded text-[11px] font-bold transition-colors">H2</button>

      <button type="button" (click)="insertHeading('h3')" title="Sous-titre H3"
        class="px-2 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded text-[11px] font-bold transition-colors">H3</button>

      <button type="button" (click)="insertParagraph()" title="Paragraphe"
        class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded text-sm font-serif transition-colors">P</button>

      <div class="w-px h-4 bg-stone-200 mx-1"></div>

      <button type="button" (click)="execFormat('insertUnorderedList')" title="Liste à puces"
        class="w-7 h-7 flex items-center justify-center text-stone-500 hover:bg-stone-200 rounded transition-colors">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
        </svg>
      </button>

      <button type="button" (click)="execFormat('insertOrderedList')" title="Liste numérotée"
        class="w-7 h-7 flex items-center justify-center text-stone-500 hover:bg-stone-200 rounded transition-colors">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" />
        </svg>
      </button>

      <button type="button" (click)="insertLink()" title="Insérer un lien"
        class="w-7 h-7 flex items-center justify-center text-stone-500 hover:bg-stone-200 rounded transition-colors">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
        </svg>
      </button>

      <div class="w-px h-4 bg-stone-200 mx-1"></div>

      <button type="button" (click)="execFormat('removeFormat')" title="Effacer la mise en forme"
        class="w-7 h-7 flex items-center justify-center text-stone-400 hover:bg-stone-200 hover:text-stone-600 rounded transition-colors">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

    </div>
  </div>

  <!-- VISUAL — contenteditable -->
  <div *ngIf="editorMode() === 'visual'"
    #visualEditor
    contenteditable="true"
    (input)="onVisualInput()"
    class="prose w-full px-4 py-3 min-h-[120px] outline-none text-stone-800 text-sm leading-relaxed"
    style="white-space: pre-wrap;">
  </div>

  <!-- CODE — raw HTML -->
  <textarea *ngIf="editorMode() === 'code'"
    [value]="value"
    (input)="onCodeInput($event)"
    placeholder="HTML…"
    rows="6"
    spellcheck="false"
    class="w-full px-4 py-3 text-sm font-mono outline-none resize-y leading-relaxed border-0"
    style="min-height:120px; background:#1e1e2e; color:#cdd6f4; tab-size:2;">
  </textarea>

</div>
